import Vue from 'vue';
import VueRouter from 'vue-router';
// import Vuetify from '../plugins/vuetify';
import store from '../store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/dashboard',
  },
  {
    path: '/login',
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/Dashboard.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/home/Home.vue'),
      },
      {
        path: 'profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/profile/Profile.vue'),
      },
      {
        path: 'demographics',
        name: 'demographics',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/demographics/Demographics.vue'),
      },
      {
        path: 'assessment',
        name: 'assessment',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/assessment/Assessment.vue'),
      },
      {
        path: 'resources',
        name: 'resourcesMain',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/resources/ResourcesMain.vue'),
      },
      {
        path: 'resources/:type',
        name: 'resources',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/resources/Resources.vue'),
      },
      {
        path: 'certifications',
        name: 'certifications',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/certifications/Certifications.vue'),
      },

      // Hidden page on drawer for carousel content
      {
        path: 'message-from-will',
        name: 'messageFromWill',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/hidden/carousel/MessageFromWill.vue'),
      },
      {
        path: 'webinar-sign-up',
        name: 'webinarSignUp',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/hidden/carousel/WebinarSignUp.vue'),
      },
      {
        path: 'ac-onboarding1',
        name: 'formOne',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/hidden/carousel/FormOne.vue'),
      },
      {
        path: 'ac-onboarding2a',
        name: 'formTwo',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/hidden/carousel/FormTwoA.vue'),
      },
      {
        path: 'ac-onboarding2b',
        name: 'formTwo',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/hidden/carousel/FormTwoB.vue'),
      },
      {
        path: 'ac-onboarding3',
        name: 'formThree',
        component: () => import(/* webpackChunkName: "dashboard" */ '../views/dashboard/content/hidden/carousel/FormThree.vue'),
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "public" */ '../views/public/404.vue'),
  },
  { path: '*', redirect: '/404', hidden: true },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.name === '404') next();
  else {
    console.log('should refresh', store.getters['common/shouldRefreshUser']);

    // shouldRefreshUser is true only when refreshing page
    // so we don t make request to get user data on every intra navigation
    if (store.getters['common/shouldRefreshUser']) {
      console.log('refresh user');
      await store.dispatch('account/getCurrentUser');
    }

    if (to.matched.some((record) => record.meta.requiresAuth)) {
      console.log('require auth', store);
      console.log('is authorized?', store.getters['account/isAuthorized']);

      // TODO: Allow login user even if the user is not coach
      // if (store.getters['account/isAuthorized']) {
      if (store.getters['account/isAuthenticate'] || store.getters['account/isBlur']) {
        console.log('is auth');
        next();
      } else {
        console.log('is NOT auth');
        next({ name: '404' });
      }
    } else {
      console.log('No auth required');
      console.log('is authenticate?', store.getters['account/isAuthenticate']);
      // If user is authenticate as not MAM, we redirect to 404
      // TODO: Allow login user even if the user is not coach
      // if (store.getters['account/isAuthenticate'] && !store.getters['account/isAuthorized']) {
      //   next({ name: '404' });
      // } else {
      //   next();
      // }
      if (!store.getters['account/isAuthenticate']) {
        next({ name: '404' });
      } else {
        next();
      }
      // /TODO: Allow login user even if the user is not coach
    }
  }
});

export default router;
